// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { InvoiceBillFrom, InvoiceBillTo } from '@/billing/api/types';
import { Box, Typography } from '@mui/material';

export function AddressBlock(props: {
  label: string;
  address: InvoiceBillFrom;
}) {
  return (
    <Box>
      <Typography
        variant="overline"
        color="text.secondary"
        sx={{ display: 'block', mb: 0.5 }}
      >
        {props.label}
      </Typography>
      <Typography variant="body2" fontWeight="bold">
        {props.address.name}
      </Typography>
      {props.address.address && (
        <Typography
          variant="body2"
          color="text.secondary"
          sx={{ whiteSpace: 'pre-line' }}
        >
          {props.address.address}
        </Typography>
      )}
    </Box>
  );
}

export function BillToBlock(props: { address: InvoiceBillTo }) {
  const { companyName, address, billingContactName, email, phone } =
    props.address;
  const hasContact = billingContactName || email || phone;

  return (
    <Box>
      <Typography
        variant="overline"
        color="text.secondary"
        sx={{ display: 'block', mb: 0.5 }}
      >
        Bill to
      </Typography>
      {companyName && (
        <Typography variant="body2" fontWeight="bold">
          {companyName}
        </Typography>
      )}
      {address && (
        <Typography
          variant="body2"
          color="text.secondary"
          sx={{ whiteSpace: 'pre-line' }}
        >
          {address}
        </Typography>
      )}

      {hasContact && (
        <>
          <Typography
            variant="overline"
            color="text.secondary"
            sx={{ display: 'block', mt: 2, mb: 0.5 }}
          >
            Billing contact
          </Typography>
          {billingContactName && (
            <Typography variant="body2" fontWeight="bold">
              {billingContactName}
            </Typography>
          )}
          {email && (
            <Typography variant="body2" color="text.secondary">
              {email}
            </Typography>
          )}
          {phone && (
            <Typography variant="body2" color="text.secondary">
              {phone}
            </Typography>
          )}
        </>
      )}
    </Box>
  );
}
